@if (product.isBackorderOnly() && product.data.in_stock_date) {
<p class="p2 ta-center col-6 m-b-3">
    {{ 'Available from' | translate }} - {{product.data.in_stock_date | formatDate}}
</p>
}